import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const jiraSmartCreationEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-jira-smart-creation" */ '../modal/index'),
		{
			moduleId: 'async-jira-smart-creation',
		},
	),
	getPreloadProps: () => ({}),
});
